import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import Navbar from "./navbar";
import QuoteManager from "./QuoteManager";
import NewsManager from "./NewsManager";
import UserManager from "./UserManager";
import LeaveManager from "./LeaveManager";
import AdminProcedures from "./AdminProcedures";
import AdminPolicies from "./AdminPolicies";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft, faNewspaper, faChartLine, faUsers, faCogs, faArrowLeft, faCalendarCheck, faClipboardList, faGavel } from "@fortawesome/free-solid-svg-icons";
import "./AdminPanel.css";

const AdminPanel = () => {
    const { user, isAdmin, loading } = useAuth();
    const [activeTab, setActiveTab] = useState("dashboard");

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }, [activeTab]);


    if (loading) {
        return <div className="admin-loading">Loading...</div>;
    }


    if (!user || !isAdmin) {
        return <Navigate to="/home" replace />;
    }

    const renderContent = () => {
        switch (activeTab) {
            case "dashboard":
                return (
                    <div className="admin-grid">
                        {/* User Management Card */}
                        <div className="admin-card" onClick={() => setActiveTab("users")}>
                            <div className="admin-card-icon">
                                <FontAwesomeIcon icon={faUsers} />
                            </div>
                            <h3>User Management</h3>
                            <p>View and manage all registered users</p>
                            <button className="admin-btn">Manage Users</button>
                        </div>

                        {/* Quote Management Card */}
                        <div className="admin-card" onClick={() => setActiveTab("quotes")}>
                            <div className="admin-card-icon">
                                <FontAwesomeIcon icon={faQuoteLeft} />
                            </div>
                            <h3>Daily Quote</h3>
                            <p>Set a unique quote for the day</p>
                            <button className="admin-btn">Manage Quote</button>
                        </div>

                        {/* News Management Card */}
                        <div className="admin-card" onClick={() => setActiveTab("news")}>
                            <div className="admin-card-icon">
                                <FontAwesomeIcon icon={faNewspaper} />
                            </div>
                            <h3>News Management</h3>
                            <p>Update notices, news, and announcements</p>
                            <button className="admin-btn">Manage News</button>
                        </div>

                        {/* Leave Management Card */}
                        <div className="admin-card" onClick={() => setActiveTab("leaves")}>
                            <div className="admin-card-icon">
                                <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <h3>Leave Requests</h3>
                            <p>Review and approve staff leave requests</p>
                            <button className="admin-btn">Manage Leaves</button>
                        </div>

                        {/* Procedures Management Card */}
                        <div className="admin-card" onClick={() => setActiveTab("procedures")}>
                            <div className="admin-card-icon">
                                <FontAwesomeIcon icon={faClipboardList} />
                            </div>
                            <h3>Procedures</h3>
                            <p>Manage company standard operating procedures</p>
                            <button className="admin-btn">Manage Procedures</button>
                        </div>

                        {/* Policies Management Card */}
                        <div className="admin-card" onClick={() => setActiveTab("policies")}>
                            <div className="admin-card-icon">
                                <FontAwesomeIcon icon={faGavel} />
                            </div>
                            <h3>Policies</h3>
                            <p>Manage company policies and guidelines</p>
                            <button className="admin-btn">Manage Policies</button>
                        </div>


                    </div>
                );
            case "quotes":
                return <QuoteManager />;
            case "news":
                return <NewsManager />;
            case "users":
                return <UserManager />;
            case "leaves":
                return <LeaveManager />;
            case "procedures":
                return <AdminProcedures />;
            case "policies":
                return <AdminPolicies />;
            case "reports":
                return <div className="placeholder-view"><h2>Reports Coming Soon</h2></div>;
            case "settings":
                return <div className="placeholder-view"><h2>Settings Coming Soon</h2></div>;
            default:
                return null;
        }
    };

    return (
        <div className="admin-panel-page">
            <Navbar />
            <div className="admin-panel-container">
                <div className="admin-header">
                    {activeTab !== "dashboard" && (
                        <button className="back-btn" onClick={() => setActiveTab("dashboard")}>
                            <FontAwesomeIcon icon={faArrowLeft} /> Back
                        </button>
                    )}
                    <h1>Admin Panel</h1>
                    <p>Welcome, {user.name || "Admin"}! Manage your portal from here.</p>
                </div>

                {renderContent()}


            </div>
        </div>
    );
};

export default AdminPanel;
